export default function ArrowIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      fill='none'
      viewBox='-2 0 14 14'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M7.17982 0.46872C7.43198 0.46872 7.68414 0.567264 7.88322 0.778426C8.2681 1.18668 8.2681 1.8624 7.88322 2.27065L3.27793 7.15555L7.88322 12.0405C8.2681 12.4487 8.26809 13.1244 7.88322 13.5327C7.49834 13.9409 6.86129 13.9409 6.47641 13.5327L1.16773 7.90166C0.782849 7.49341 0.782849 6.81769 1.16773 6.40944L6.47641 0.778426C6.67549 0.567263 6.92765 0.46872 7.17982 0.46872Z'
        fill="currentColor"
      />
    </svg>
  );
}
